import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "/api/cashflow";

export const CashFlowApi = {
  getDiario: async (empresa, year) => {
    const res = await axios.get(`${API_URL}/diario/${empresa}`, {
      params: { year },
    });
    return res.data;
  },
};
